import React, { DetailedHTMLProps, HTMLAttributes } from "react"

import { styled } from "@mui/material"

import { MatSymbol } from "@cirrus/ui-kit-ts/src/components/atoms/MatSymbol"
import { Tooltip } from "@cirrus/ui-kit-ts/src/components/atoms/Tooltip"

// TODO: Replace with i18n from "useTranslations". 
// For now uses i18n as props to support translations in Author part without using expensive Provider wrapper;
// Can use useTranslations hook safely here after proper refactoring of the Header component in Author;

export const LoggedInAsAnotherUser = styled(({ i18n, ...props }: LoggedInAsAnotherUserProps) => {
  return (
    <div id="logged-in-as-another-user" {...props}>
      <Tooltip title={i18n("LoginAs:LoggedInAsAnotherUserTooltip")}>
        <MatSymbol
          name="emergency_home"
          size={18}
          sx={{
            color: "inherit",
            verticalAlign: "middle",
            cursor: "default",
          }}
        />
      </Tooltip>

      {i18n("LoginAs:LoggedInAsAnotherUser")}
    </div>
  )
})({
  display: "flex",
  alignItems: "center",
  columnGap: ".8rem",
  textTransform: "uppercase",
  fontWeight: 700,
  fontSize: "1.4rem",
  lineHeight: "2.4rem",
})

export type LoggedInAsAnotherUserProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
  i18n: (key: string) => string
}
